'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

var _dec, _class, _desc, _value, _class2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactRedux = require('react-redux');

var _utils = require('helpers/utils');

var _components = require('components');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _cloud = require('redux/modules/cloud');

var cloudActions = _interopRequireWildcard(_cloud);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var service = 'boxcom';

var BoxcomConnectButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    csrfState: state.cloud[service].csrfState,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, cloudActions, authActions)), _dec(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  (0, _inherits3.default)(BoxcomConnectButton, _Component);

  function BoxcomConnectButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BoxcomConnectButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BoxcomConnectButton.__proto__ || (0, _getPrototypeOf2.default)(BoxcomConnectButton)).call.apply(_ref, [this].concat(args))), _this), _this.onAuth = function (e) {
      var _this$props = _this.props,
          csrfState = _this$props.csrfState,
          boxcomGetToken = _this$props.boxcomGetToken,
          updateBoxToken = _this$props.updateBoxToken;

      window.removeEventListener('onBoxcomAuth', _this.onAuth);

      setTimeout(function () {
        _this.authWindow.close();
        _this.authWindow = null;
      }, 1000);

      if (e.detail.state === csrfState) {
        var authCode = e.detail.code;
        boxcomGetToken(authCode).promise.then(function (resp) {
          return updateBoxToken(service, resp.data);
        });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(BoxcomConnectButton, [{
    key: 'connect',
    value: function connect() {
      var setCSRFState = this.props.setCSRFState;

      var state = Date.now().toString();
      setCSRFState(service, state);

      var boxUrl = 'https://account.box.com/api/oauth2/authorize';
      var redirectUri = encodeURIComponent(document.location.origin + '/processing/cloudauth/boxcom');
      var clientId = _config2.default.app.boxcom.clientId;
      var authUrl = boxUrl + '?response_type=code&client_id=' + clientId + '&redirect_uri=' + redirectUri + '&state=' + state;
      this.authWindow = (0, _utils.popupWindowCenter)(authUrl, service, 400, 500);
      window.addEventListener('onBoxcomAuth', this.onAuth);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          connectClassName = _props.connectClassName,
          disconnectClassName = _props.disconnectClassName;

      var isConnected = !!(0, _get4.default)(user, 'boxcomToken', false);

      return _react2.default.createElement(_components.CloudConnectButton, {
        isConnected: isConnected,
        service: service,
        connectClassName: connectClassName,
        disconnectClassName: disconnectClassName,
        connect: this.connect
      });
    }
  }]);
  return BoxcomConnectButton;
}(_ClientSideComponent2.default), _class3.propTypes = {
  boxcomGetToken: _propTypes2.default.func,
  connectClassName: _propTypes2.default.string,
  csrfState: _propTypes2.default.string,
  disconnectClassName: _propTypes2.default.string,
  setCSRFState: _propTypes2.default.func,
  updateBoxToken: _propTypes2.default.func,
  user: _propTypes2.default.object
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'connect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'connect'), _class2.prototype)), _class2)) || _class);
exports.default = BoxcomConnectButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Boxcom/BoxcomConnectButton.js
// module id = 1959
// module chunks = 1